import React from "react";
import {Link} from "react-router-dom";
import {HashLink} from "react-router-hash-link";

/**
 * Sticky top nav for the EAS landing page. The "Get EAS →" CTA points at /system.
 * Hash links use react-router-hash-link so they smooth-scroll the same-page
 * anchors (#mission, #system, #founder).
 */
export default function EasLandingNav(): JSX.Element {
    return (
        <nav style={navStyle}>
            <div className="eas-container eas-landing-nav" style={innerStyle}>
                <Link to="/" style={logoStyle}>
                    <img
                        src="https://produkacja.s3.eu-central-1.amazonaws.com/web/logo/logo-500-500-raw.png"
                        alt="Produkacja"
                        style={logoMarkStyle}
                    />
                    <span>Effective Action System</span>
                </Link>
                <div style={linksStyle}>
                    <HashLink smooth to="/#mission" className="eas-landing-nav-link" style={linkStyle}>Mission</HashLink>
                    <HashLink smooth to="/#system" className="eas-landing-nav-link" style={linkStyle}>System</HashLink>
                    <HashLink smooth to="/#founder" className="eas-landing-nav-link" style={linkStyle}>Manifesto</HashLink>
                    <Link to="/system" style={ctaStyle}>Get EAS →</Link>
                </div>
            </div>
        </nav>
    );
}

const navStyle: React.CSSProperties = {
    position: "sticky", top: 0, zIndex: 50,
    background: "rgba(11,20,16,0.7)", backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
};
const innerStyle: React.CSSProperties = {display: "flex", alignItems: "center", justifyContent: "space-between", padding: "18px 32px"};
const logoStyle: React.CSSProperties = {display: "flex", alignItems: "center", gap: 10, fontWeight: 600, fontSize: 16, letterSpacing: "-0.01em", textDecoration: "none", color: "#fff"};
// Cat-with-glasses Produkacja mark — same image used across produkacja.pl.
const logoMarkStyle: React.CSSProperties = {width: 28, height: 28, borderRadius: 6, flexShrink: 0, display: "block", objectFit: "cover"};
const linksStyle: React.CSSProperties = {display: "flex", gap: 28, alignItems: "center", fontSize: 14};
const linkStyle: React.CSSProperties = {textDecoration: "none", color: "rgba(255,255,255,0.65)", transition: "color .2s"};
const ctaStyle: React.CSSProperties = {background: "#2ad167", color: "#0b1410", padding: "9px 18px", borderRadius: 999, fontWeight: 600, textDecoration: "none"};
